import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { StartEndDate } from 'app/models/container-occupancy-empty-full-rate.model';
import { DeviceAllRequest } from 'app/models/deviceAllRequest.model';
import { DeviceLatestStatus } from 'app/models/device-latest-status.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeviceRequestService {

    request: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }


    // getDeviceRequests(companyId: number): Promise<Array<DeviceLatestStatus>> {

    //     return new Promise((resolve, reject) => {
    //         this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/" + companyId)
    //             .subscribe((response: any) => {
    //                 this.request = response;
    //                 this.onChanged.next(this.request);
    //                 resolve(response);
    //             }, reject);
    //     });
    // }

    GetByDayDeviceDetails(C_Id: string,date:Date): Promise<Array<DeviceLatestStatus>> {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        var dateTime = new Date(date);
        var sed = new StartEndDate();
        sed.startTime = date;
        sed.endTime = new Date(dateTime.setHours(date.getHours()+24));
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "requests/GetByDayDeviceDetails/" + parseInt(C_Id),sed)
                .subscribe((response: any) => {
                    this.request = response;
                    this.onChanged.next(this.request);
                    resolve(response);
                }, reject);
        });
    }

    getByDateBetweenRequests(C_Id: string, startTime: Date,endTime:Date): Promise<Array<DeviceAllRequest>> {
        var sed = new StartEndDate();
        sed.startTime = startTime;
        sed.endTime = endTime;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "requests/getByDateBetweenRequests/"+C_Id,sed)
                .subscribe((response: any) => {
                    this.request = response;
                    this.onChanged.next(this.request);
                    resolve(response);
                }, reject);
        });
    }

    getRequestAllPaginated(deviceId:string,page:number,count:number,sortKey:string,sortType:string): Promise<Array<DeviceAllRequest>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/requestbyalldetail/"+deviceId +"/"+page+"/"+count+"/"+sortKey+"/"+sortType)// modifier
                .subscribe((response: any) => {
                    this.request = response;
                    this.onChanged.next(this.request);
                    resolve(response);
                }, reject);
        });
    }
    getRequestCount(deviceId: string): Promise<number> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/requestbycount/" +deviceId)// modifier
                .subscribe((response: any) => {
                    this.request = response;
                    this.onChanged.next(this.request);
                    resolve(response);
                }, reject);
        });
    }

    containerDailyFilling(deviceId: string): Promise<number> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/containerDailyFilling/" +deviceId)// modifier
                .subscribe((response: any) => {
                      const link = document.createElement('a');
                      link.setAttribute('target', '_blank');
                      link.setAttribute('href', this.appConfigService.apiConfig["api-url"]+"ContainerDailyFilling/"+response+".xlsx");
                      link.setAttribute('download', response+".xlsx");
                      document.body.appendChild(link);
                      link.click();
                    this.request = response;
                    this.onChanged.next(this.request);
                    resolve(response);
                }, reject);
        });
    }
}
